export interface UserDetailsOrganization {
  organizationId: number;
  organizationName: string;
  isActive: boolean;
  organizationLogoUrl: string | null;
}

export interface UserDetailsRole {
  roleId: number;
  roleName: string;
  roleKey: string;
}

export interface UserDetailsPermission {
  permissionId: number;
  permissionName: string;
  permissionKey: string;
  isInherited: boolean;
  isCustom: boolean;
  isAssigned: boolean;
}

export interface UserDetailsFeature {
  featureId: number;
  featureName: string;
  featureKey: string;
  isMainMenu: boolean;
  permissions: UserDetailsPermission[];
}

export interface UserDetailsBrand {
  brandId: number;
  brandName: string;
  brandLogoUrl: string | null;
  organizationId: number;
  organizationName: string;
  brandUserMappingId: number;
  isAccessActive: boolean;
  roles: UserDetailsRole[];
  features: UserDetailsFeature[];
}

export interface IUserDetailsProps {
  userId: number;
  authId: string;
  firstName: string;
  lastName: string;
  email: string;
  isActive: boolean;
  isBot: boolean;
  kind: string;
  createdAt: string;
  deletedAt: string | null;
  organizations: UserDetailsOrganization[];
  brands: UserDetailsBrand[];
}

export class UserDetails {
  private readonly _props: IUserDetailsProps;

  constructor(props: IUserDetailsProps) {
    this._props = props;
  }

  get userId(): number {
    return this._props.userId;
  }
  get authId(): string {
    return this._props.authId;
  }
  get firstName(): string {
    return this._props.firstName;
  }
  get lastName(): string {
    return this._props.lastName;
  }
  get fullName(): string {
    return `${this._props.firstName} ${this._props.lastName}`.trim();
  }
  get email(): string {
    return this._props.email;
  }
  get isActive(): boolean {
    return this._props.isActive;
  }
  get isBot(): boolean {
    return this._props.isBot;
  }
  get kind(): string {
    return this._props.kind;
  }
  get createdAt(): string {
    return this._props.createdAt;
  }
  get deletedAt(): string | null {
    return this._props.deletedAt;
  }
  get organizations(): UserDetailsOrganization[] {
    return this._props.organizations;
  }
  get brands(): UserDetailsBrand[] {
    return this._props.brands;
  }
}
